if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      connectedCallback() {
        if (this.dataset.variantId) {
          this.update({ id: this.dataset.variantId, available: !this.hidden });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      update(variant) {
        this.abortController?.abort();

        if (!variant?.id || !variant.available) {
          this.innerHTML = '';
          this.hidden = true;
          return;
        }

        this.abortController = new AbortController();
        const rootUrl = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');

        fetch(`${rootUrl}variants/${variant.id}/?section_id=pickup-availability`, {
          signal: this.abortController.signal,
        })
          .then((response) => {
            if (!response.ok) throw new Error('Pickup availability could not be loaded');
            return response.text();
          })
          .then((html) => {
            const content = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('.pickup-availability-content');

            if (!content) {
              this.innerHTML = '';
              this.hidden = true;
              return;
            }

            this.innerHTML = content.outerHTML;
            this.hidden = false;
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              this.innerHTML = '';
              this.hidden = true;
            }
          });
      }
    }
  );
}
